{
  "name": "@aeronexo/web",
  "version": "0.14.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "vite build",
    "build:pages": "vite build && node scripts/prepare-pages.mjs",
    "dev": "vite",
    "preview": "vite preview",
    "typecheck": "tsc -p tsconfig.json"
  },
  "dependencies": {
    "@aeronexo/contracts": "workspace:*",
    "better-auth": "1.7.2",
    "react": "19.2.8",
    "react-dom": "19.2.8"
  },
  "devDependencies": {
    "@types/react": "19.2.18",
    "@types/react-dom": "19.2.5",
    "@vitejs/plugin-react": "6.1.0",
    "vite": "8.2.2"
  }
}
